import React, { Component } from "react";
import AuthError from "../views/AuthError";
import AuthOK from "../views/AuthOK";
import Loading from "../views/Loading";
import InsertPhone from "../views/InsertPhone";
import TextTerms from "../views/TextTerms";
import Panel from "../components/Panel";
import InserCode from "../views/InsertCode";
import valenet from "../services/valenet";
import Cookies from "universal-cookie";
import ReactGA from "react-ga";

const phoneValidator = /^\([1-9]{2}\) 9 [0-9]{4}-[0-9]{4}$/g;

const cpfValidator = (cpf) => {
	cpf = cpf.replace(/[^\d]+/g, "");
	if (cpf == "") return false;

	// Valida 1o digito
	let add = 0;
	for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
	let rev = 11 - (add % 11);
	if (rev == 10 || rev == 11) rev = 0;
	if (rev != parseInt(cpf.charAt(9))) return false;

	// Valida 2o digito
	add = 0;
	for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
	rev = 11 - (add % 11);
	if (rev == 10 || rev == 11) rev = 0;
	if (rev != parseInt(cpf.charAt(10))) return false;
	return true;
};

const emailValidator = /^(([^<>()\[\]\\.,;:*{}'/?|!#$%¨&+=´`~^\s@"]+(\.[^<>()\[\]\\.,;:*{}'/?|!#$%¨&+=´`~^\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))[\s]?$/; // permitir um espaço no final (Android adiciona espaço no final ao usar 'auto-complete')
//const emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const codeValidator = /^[0-9]{4}$/g;
class HotspotAuth extends Component {
	constructor(props) {
		super(props);

		this.initialState = {
			phone: "",
			phoneValidatorError: "",
			phoneIsValid: false,
			email: "",
			emailValidatorError: "",
			emailIsValid: false,
			cpf: "",
			cpfValidatorError: "",
			cpfIsValid: false,
			smsSending: false,
			smsOK: false,
			smsError: false,
			sendSMS: false,
			code: "",
			codeValidatorError: "",
			codeIsValid: false,
			codeSending: false,
			codeOK: false,
			codeError: false,
			requestError: false,
			requestErrorMessage: null,
			readyToValenetWorld: false,
			initRoute: this.props.initRoute,
			terms: false,
		};
		this.state = this.initialState;
	}

	resetHandler = () => {
		this.setState(this.initialState);
	};

	navigateHandler = () => {
		const newState = { readyToValenetWorld: true };
		this.setState(() => newState);
		this.props.onReady();
		window.location.assign(this.props.envObj.redirectUrl);
	};

	resendSmsHandler = () => {
		this.sendPhoneNumber();
	};

	phoneIsValid = (phone) => {
		const isValid = new RegExp(phoneValidator).test(phone);
		return isValid;
	};

	cpfIsValid = (cpf) => {
		const isValid = cpfValidator(cpf);
		console.log(isValid);
		return isValid;
	};

	emailIsValid = (email) => {
		const isValid = new RegExp(emailValidator).test(email);
		return isValid;
	};

	codeIsValid = (code) => {
		const isValid = new RegExp(codeValidator).test(code);
		return isValid;
	};

	handlePhoneChange = (value, field) => {
		if (field === "phone") {
			//Phone
			let newState = {};
			newState.phone = value;

			newState.phoneIsValid = this.phoneIsValid(value);
			newState.phoneValidatorError = !newState.phoneIsValid && "O número de telefone inserido é inválido";

			//console.log(newState);

			this.setState(() => newState);
		} else if (field === "cpf") {
			//CPF
			let newState = {};

			newState.cpf = value;

			newState.cpfIsValid = this.cpfIsValid(value);
			newState.cpfValidatorError = !newState.cpfIsValid && "O CPF inserido é inválido";

			//console.log(newState);

			this.setState(() => newState);
		} else {
			//email
			let newState = {};
			newState.email = value;

			newState.emailIsValid = this.emailIsValid(value);
			newState.emailValidatorError = !newState.emailIsValid && "O email inserido é inválido";

			this.setState(() => newState);
		}
	};

	handleEmailChange = (email) => {
		let newState = {};
		newState.email = email;

		newState.emailIsValid = this.emailIsValid(email);
		newState.emailValidatorError = !newState.emailIsValid && "O email inserido é inválido";
		this.setState(() => newState);
	};

	handleCodeChange = (value) => {
		let newState = {};
		newState.code = value;
		newState.codeIsValid = this.codeIsValid(value);
		newState.codeValidatorError = !newState.codeIsValid && "O código inserido não está correto";
		this.setState(() => newState);
	};
	sendPhoneNumber = () => {
		const { phone, email, cpf } = this.state;
		let newState = { smsSending: true, smsOK: false, smsError: false };
		this.setState(() => newState);

		valenet.send(phone, email, cpf, this.props.envObj).then((res) => {
			const { data } = res;
			if (res.data === true || res === true || res.success === true) {
				return this.smsRecived(data);
			} else {
				return this.requestError(data);
			}
		});
	};

	openCloseTerms = (state) => {
		this.setState({ terms: state });
	};

	smsRecived = () => {
		this.setState({ smsSending: false, smsOK: true, smsError: false });
	};

	cleanMask = (number) => {
		var ret = number;
		ret = ret.split("(").join("");
		ret = ret.split(")").join("");
		ret = ret.split("-").join("");
		ret = ret.split(" ").join("");
		return ret;
	};

	sendCode = () => {
		const { phone, code, email, cpf } = this.state;
		this.setState({ codeSending: true, codeOK: false, codeError: false });

		valenet.validate("55" + phone, code, null, email, cpf, this.props.envObj).then((res) => {
			const { data } = res;
			if (res.data === true || res === true || res.success === true) {
				return this.codeRecived(data);
			} else {
				return this.requestError(data);
			}
		});
	};

	codeRecived = (data) => {
		this.setState({ codeSending: false, codeOK: true, codeError: false });
	};

	requestError = (data) => {
		const newState = {
			phone: "",
			phoneValidatorError: "",
			phoneIsValid: false,
			email: "",
			emailValidatorError: "",
			emailIsValid: false,
			cpf: "",
			cpfValidatorError: "",
			cpfIsValid: false,
			smsSending: false,
			smsOK: false,
			smsError: false,
			sendSMS: false,
			code: "",
			codeValidatorError: "",
			codeIsValid: false,
			codeSending: false,
			codeOK: false,
			codeError: false,
			requestError: true,
			requestErrorMessage: data.message,
			readyToValenetWorld: false,
			initRoute: this.props.initRoute,
			terms: false,
		};
		this.setState(newState);
	};

	render() {
		return <Panel>{this.renderView()}</Panel>;
	}

	renderView() {
		let {
			phone,
			phoneIsValid,
			phoneValidatorError,
			email,
			emailIsValid,
			emailValidatorError,
			cpf,
			cpfIsValid,
			cpfValidatorError,
			smsSending,
			smsOK,
			smsError,
			code,
			codeIsValid,
			codeValidatorError,
			codeSending,
			codeOK,
			codeError,
			requestError,
			requestErrorMessage,
			readyToValenetWorld,
			initRoute,
			terms,
		} = this.state;
		//console.log("this.props.envObj.autoLogin", this.props.envObj.autoLogin);
		const cookies = new Cookies();
		var t = this;

		if (initRoute === "InserCode" && cookies.get("state") && !requestError) {
			var phoneCookies = cookies.get("state").phone;
			const newState = { phone: phoneCookies, phoneIsValid: true, smsOK: true, phoneValidatorError: false, initRoute: false };
			t.setState(() => newState);
			initRoute = false;
		}

		if (terms === true || initRoute === "Terms") {
			return <TextTerms callTerms={this.openCloseTerms} terms={terms} valid={phoneIsValid} />;
		} else if ((requestError && initRoute === false) || initRoute === "AuthError") {
			return <AuthError message={requestErrorMessage} onResetClick={this.resetHandler} />;
		} else if ((!smsSending && !smsOK && initRoute === false) || initRoute === "InsertPhone") {
			return (
				<InsertPhone
					sendFoneHandler={this.sendPhoneNumber}
					onChange={this.handlePhoneChange}
					value={phone}
					valueEmail={email}
					valueCPF={cpf}
					callTerms={this.openCloseTerms}
					valid={phoneIsValid}
					validEmail={emailIsValid}
					validCPF={cpfIsValid}
					errorMessage={phoneValidatorError}
					errorMessageEmail={emailValidatorError}
					errorMessageCPF={cpfValidatorError}
					envObj={this.props.envObj}
				/>
			);
		} else if ((phone && smsSending && initRoute === false && this.props.envObj.autoLogin === false) || initRoute === "LoadingEnviandoSMS") {
			//const cookies = new Cookies();
			//cookies.set('state', (this.state), { path: '/', expires: new Date(Date.now()+300000)});

			return <Loading title="Enviando SMS" />;
		} else if ((phone && smsOK && !codeOK && initRoute === false && this.props.envObj.autoLogin === false) || initRoute === "InserCode") {
			return (
				<InserCode
					sendCodeHandler={this.sendCode}
					onChange={this.handleCodeChange}
					phone={phone}
					value={code}
					valid={codeIsValid}
					onResendClick={this.resendSmsHandler}
					errorMessage={codeValidatorError}
				/>
			);
		} else if ((smsOK && code && codeSending && initRoute === false && this.props.envObj.autoLogin === false) || initRoute === "LoadingVerificandoSMS") {
			return <Loading title="Verificando código SMS" />;
		} else if ((codeOK && !readyToValenetWorld && initRoute === false) || initRoute === "AuthOK" || this.props.envObj.autoLogin === true) {
			//console.log('window.location:', window.location)
			//console.log('this.state:', this.state)

			document.cookie = `hotspot_valenet_client=${this.state.phone}; path=/`;
			//console.log('AuthOK| hotspot_valenet_client:', cookies.get('hotspot_valenet_client'))

			if (!this.state.showFinalComponent) {
        			setTimeout(() => {
		                    this.setState({ showFinalComponent: true });
        		        }, 10000);

	               		return <Loading title="Finalizando autenticação, aguarde..." />;
            		}

			ReactGA.pageview("/AuthOK" + window.location.pathname);

			return <AuthOK onBeginClick={this.navigateHandler} envObj={this.props.envObj} />;
		} else if (codeOK && readyToValenetWorld) {
		}
	}
}

export default HotspotAuth;

// Deletando os Cookies
/*
document.cookie = 'initRoute' + "=" + "; expires=Thu, 01-Jan-70 00:00:01 GMT";
document.cookie = 'state' + "=" + "; expires=Thu, 01-Jan-70 00:00:01 GMT";
document.cookie = 'timeToExpire' + "=" + "; expires=Thu, 01-Jan-70 00:00:01 GMT";
*/
